import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/theme.css';
import './styles/index.css';
import './styles/widgets.css';
import './styles/sysmon.css';
// i18n 必须在 createRoot 之前 import,否则首帧 useTranslation() 拿不到资源。
import './i18n';
import { OSShell } from './OSShell';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root not found');
}

createRoot(container).render(
  <React.StrictMode>
    <OSShell />
  </React.StrictMode>,
);
